var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0833 21.5835H6.91659C4.24721 21.5835 2.08325 23.7475 2.08325 26.4168V40.9168C2.08325 43.5862 4.24721 45.7502 6.91659 45.7502H31.0833C33.7526 45.7502 35.9166 43.5862 35.9166 40.9168V26.4168C35.9166 23.7475 33.7526 21.5835 31.0833 21.5835Z",
    stroke: "#2F4160",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 38.5002C21.6695 38.5002 23.8334 36.3362 23.8334 33.6668C23.8334 30.9975 21.6695 28.8335 19.0001 28.8335C16.3307 28.8335 14.1667 30.9975 14.1667 33.6668C14.1667 36.3362 16.3307 38.5002 19.0001 38.5002Z",
    fill: "#94D0F3",
    stroke: "#2F4160",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 21.5833V11.9167C9.33325 9.35291 10.3517 6.89415 12.1646 5.0813C13.9774 3.26845 16.4362 2.25 18.9999 2.25C21.5637 2.25 24.0224 3.26845 25.8353 5.0813C27.6481 6.89415 28.6666 9.35291 28.6666 11.9167V21.5833",
    stroke: "#2F4160",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon);
export default __webpack_public_path__ + "static/media/Privacy-Icon.ddebcac3.svg";
export { ForwardRef as ReactComponent };